import { Component, ViewEncapsulation } from '@angular/core';
import { Language } from '@app/shared/models/language.model';
import { InternationalizationService } from '@core/services/internationalization.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-language-select',
    templateUrl: './language-select.component.html',
    styleUrls: ['./language-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class LanguageSelectComponent {
    languages: Language[] = [];
    selectedLanguage: Language;

    constructor(private internationalizationService: InternationalizationService) {
        this.languages = this.internationalizationService.languages;
        this.internationalizationService.currentLanguage
            .pipe(take(1))
            .subscribe((language) => (this.selectedLanguage = language));
    }

    setCurrentLanguage(language: Language) {
        this.internationalizationService.setCurrentLanguage(language);
        this.selectedLanguage = language;
    }
}
